import { Icon } from "semantic-ui-react";

import React from "react";

import themeColors from "../../constants/themeColors";

const backgroundColors = {
	green: themeColors.GREEN_FADED,
	blue: themeColors.BLUE_FADED,
	red: themeColors.RED_FADED,
	grey: themeColors.GREY_FADED,
};

export default function BigIcon({ name, color, ...props }) {
	return (
		<Icon
			inverted
			color={color}
			name={name}
			style={{
				width: "3em",
				height: "3em",
				lineHeight: "3em",
				marginBottom: "0.75em",
				textAlign: "center",
				fontSize: 24,
				borderRadius: "100%",
				background: backgroundColors[color] || backgroundColors.grey,
			}}
			{...props}
		/>
	);
}
